import { render, staticRenderFns } from "./C-3-1a-2__ProductInfoEdit_Info&KSP.vue?vue&type=template&id=8f7305c6&"
import script from "./C-3-1a-2__ProductInfoEdit_Info&KSP.vue?vue&type=script&lang=js&"
export * from "./C-3-1a-2__ProductInfoEdit_Info&KSP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VIcon,VTextField,VTextarea})
